var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-layout-body-menu',{attrs:{"menu":[
    {title:'分类',path:'/card/merchant/cate'},
    {title:'入驻中',path:'/card/merchant/manage'},
    {title:'已停用',path:'/card/merchant/stop'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }